import { render, staticRenderFns } from "./NumberManage.vue?vue&type=template&id=1f9fce0c&scoped=true&"
import script from "./NumberManage.vue?vue&type=script&lang=js&"
export * from "./NumberManage.vue?vue&type=script&lang=js&"
import style0 from "./NumberManage.vue?vue&type=style&index=0&id=1f9fce0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fce0c",
  null
  
)

export default component.exports